<script lang="ts">
    import {onMount} from "svelte";
    import {fullCustomer} from "$lib/calls/customer";
    import {page} from "$app/stores";
    import PageLayout from "$lib/components/PageLayout.svelte";
    import CustomerAvatar from "$lib/components/CustomerAvatar.svelte";
    import {Alert, Button, Card, Dropdown, DropdownItem, Heading, TabItem, Tabs, Toggle} from "flowbite-svelte";
    import GeneralTab from "$lib/partials/client/GeneralTab.svelte";
    import {PenSolid} from "flowbite-svelte-icons";
    import LogoUploadModal from "$lib/partials/client/LogoUploadModal.svelte";
    import CustomerAssociateList from "$lib/partials/client/CustomerAssociateList.svelte";
    import {beforeNavigate} from "$app/navigation";
    import {put} from "$lib/api";
    import CardLayout from "$items/CardLayout.svelte";
    import ClientContactCard from "$lib/partials/client/ClientContactCard.svelte";

    $: customer = $page.data.customer;

    let rerendering = false;
    beforeNavigate(ev => {

        if (!ev.to.url.pathname.startsWith('/client/')) {
            rerendering = true
        }
    })
    const updateCustomer = async () => {
        customer = await put('/customer/' + customer.uuid, customer)
    }

    let logoUploadModal = false;
</script>
<svelte:head>
    <title>{customer.name} </title>
</svelte:head>
<div class="flex flex-col lg:flex-row gap-3">
    <div class="flex flex-col gap-7 xl:max-w-sm">
        <ClientContactCard bind:customer/>
    </div>
    <div class="flex flex-col 2xl:flex-row gap-3 w-full">
        <div class="flex flex-col w-full gap-7">
            <CardLayout title="Reminder"></CardLayout>
            <CardLayout title="Headquarter Anschrift">
                <p>Rechnungsanschrift: wie TC</p>
                <p>Sortabletable: Ansprechpartner</p>
            </CardLayout>
            <CardLayout title="Niederlassung Y - woanders">
                <p>"Lieferanschrift"</p>
                <p>Rechnungsanschrift (inherit)</p>
                <p>invoice email-Addresse</p>
                <p>Sortabletable: Ansprechpartner</p>
            </CardLayout>
        </div>
        <div class="max-w-sm w-full">TL
            <Alert color="red" dismissable>Consortium 286</Alert>
        </div>
    </div>
</div>
    <!--<section>

        {#if rerendering}
            rerendering...
        {:else}
        <LogoUploadModal bind:customer bind:open={logoUploadModal}/>
        {#if customer}
            <div>
                <Card class="max-w-full">
                    <div class="flex gap-3 -ml-3">
                        <CustomerAvatar size="3xl" {customer}/>
                        <div class="flex-1">
                            <Heading tag="h3" class="text-neutral-600">{customer.name}</Heading>
                            <p class="mt-1 max-w-2xl text-sm leading-6 text-gray-500">Kunde: {customer.registry}</p>
                        </div>
                        <div>
                            <Button color="alternative" size="sm">
                                <PenSolid class="w-3 h-3 mr-2"/>
                                Bearbeiten
                            </Button>
                            <Dropdown>
                                <DropdownItem on:click={() => logoUploadModal = true}>Logo upload</DropdownItem>
                            </Dropdown>
                        </div>
                    </div>
                </Card>
                <Tabs style="underline">
                    <TabItem open title="Allgemein">
                        <GeneralTab {customer}/>
                    </TabItem>
                    <TabItem title="Ansprechpartner">
                        <CustomerAssociateList associates={customer.associates}/>
                    </TabItem>
                    <TabItem title="Globale Einstellungen">
                        <article>
                            <Toggle on:change={updateCustomer} bind:checked={customer.realTimeCheckin}>Checkin/Checkout Echtzeit</Toggle>
                        </article>

                    </TabItem>
                </Tabs>


            </div>
        {/if}
        {/if}
    </section>-->

